import { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import Iconify from '../../../../reusable-components/iconify';
import CloseIconButton from '../../../../reusable-components/basic-buttons/CloseIconButton';
import { FacilityTab } from '.';

NewFacilityModal.propTypes = {
  companies: PropTypes.array,
  categories: PropTypes.array,
  data: PropTypes.array,
  fetchData: PropTypes.func,
};

export default function NewFacilityModal({ categories, companies, data, fetchData }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        sx={{ mr: 1 }}
        size="small"
        color="secondary"
        onClick={handleClickOpen}
        startIcon={<Iconify icon="eva:plus-outline" />}
      >
        New Facility
      </Button>
      <Dialog open={open} maxWidth="xl" fullWidth onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleClose();
      }}>
        <DialogTitle
          sx={{
            textAlign: 'center',
          }}
        >
          New Facility
          <CloseIconButton onClick={handleClose}/>
        </DialogTitle>
        <DialogContent sx={{ height: '100%', width: '100%' }}>
          <FacilityTab categories={categories} companies={companies} data={data} fetchData={fetchData} isAddFacilityModal />
        </DialogContent>
      </Dialog>
    </>
  );
}
